import Keycloak from 'keycloak-js';
import config from "@AppConfig";

const createKeycloak = () => new Keycloak(config.keycloak);

export default createKeycloak;
